import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-motor-vehicle-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.75 17C22.1478 17 22.5294 16.842 22.8107 16.5607C23.092 16.2794 23.25 15.8978 23.25 15.5V13.249C23.2497 12.7693 23.0591 12.3093 22.72 11.97L20.25 9.5H3.75L1.28 11.97C0.940914 12.3093 0.750302 12.7693 0.75 13.249V15.5C0.75 15.8978 0.908035 16.2794 1.18934 16.5607C1.47064 16.842 1.85218 17 2.25 17H21.75Z"
        [attr.stroke]="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.912109 12.5H4.62911C5.02666 12.5001 5.40791 12.658 5.68911 12.939L6.75011 14"
        [attr.stroke]="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.088 12.5H19.371C18.9735 12.5001 18.5922 12.658 18.311 12.939L17.25 14"
        [attr.stroke]="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.75 9.5L5.45 4.96C5.61083 4.5307 5.89902 4.1608 6.27595 3.89986C6.65288 3.63892 7.10056 3.4994 7.559 3.5H16.441C16.8989 3.50001 17.3459 3.63981 17.7223 3.90071C18.0986 4.16161 18.3863 4.53118 18.547 4.96L20.247 9.5H3.75Z"
        stroke="#00D5D3"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.75 9.5L2.25 8H0.75"
        [attr.stroke]="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.25 9.5L21.75 8H23.25"
        [attr.stroke]="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.25 17V18.5C2.25 18.8978 2.40804 19.2794 2.68934 19.5607C2.97064 19.842 3.35218 20 3.75 20C4.14782 20 4.52936 19.842 4.81066 19.5607C5.09196 19.2794 5.25 18.8978 5.25 18.5V17H2.25Z"
        [attr.stroke]="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.75 17V18.5C21.75 18.8978 21.592 19.2794 21.3107 19.5607C21.0294 19.842 20.6478 20 20.25 20C19.8522 20 19.4706 19.842 19.1893 19.5607C18.908 19.2794 18.75 18.8978 18.75 18.5V17H21.75Z"
        [attr.stroke]="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
})
export class MotorVehicleInsuranceIconComponent extends BaseIconComponent {}
